module.exports = __webpack_public_path__ + "static/media/banner.bf522e59.png";